import {Component, OnDestroy, OnInit} from '@angular/core';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {Observable} from 'rxjs';
import {
  SyncProjectEntityToCompanyCommand,
  ResetAutoLogicCommand,
  ResetHallmarkKeywordCommand, SaveHallmarkKeywordCommand
} from '../../commands/dac6-reporter.command';
import {CommandService} from '@core/services/command.service';
import {DialogService} from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {QueryProvider} from '@shared/queries/query-provider';
import {take} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {DialogModel} from "@shared/models/dialog.model";
import {SetCurrentHallmarkTagKeyAction, SetActivityFeedAction} from "@shared/components/platform-sidebar/store/platform-sidebar.action";
import {Store} from "@ngrx/store";
import {PlatformSidebarState} from "@shared/components/platform-sidebar/store/platform-sidebar.reducer";
import {HallmarkTaggingService} from "@core/services/hallmark-tagging.service";
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {PlatformCommandResponse} from "@shared/commands/command-base";

@Component({
    standalone: false,
    selector: 'particle-reporting-logic-content',
  templateUrl: './reporting-logic-content.component.html',
  styleUrls: ['./reporting-logic-content.component.scss']
})
export class ReportingLogicContentComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  selectedFieldSectionIndex: number;
  reportingLogicConfig$: Observable<any>;
  tabIndex: number;
  childIndex: number;
  helpNote: string[];
  reportingLogicConfig: any;
  viewDetails: boolean = false;
  constructor(private dac6RepoterApiService: Dac6ReporterApiService,
              private commandService: CommandService,
              private dialogService: DialogService,
              private fuseSplashscreen: FuseSplashScreenService,
              public activatedRoute: ActivatedRoute,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private hallmarkTaggingService: HallmarkTaggingService) {
    this.selectedFieldSectionIndex = -1;
    this.childIndex = 0;
  }

  reset() {
    this.fuseSplashscreen.show();
    const command = new ResetAutoLogicCommand();
    this.commandService.executeCommand(command).subscribe(state=>{
      this.fuseSplashscreen.hide();
      this.selectedFieldSectionIndex = 3;
    });
  }

  onTabIndexChange($event) {
    this.childIndex = 0;
    if( this.selectedFieldSectionIndex == -1){
      this.selectedFieldSectionIndex = 2;
      return;
    }
    if (this.tabIndex != null) {
      this.selectedFieldSectionIndex = this.tabIndex;
      this.tabIndex = null;
      return;
    }
    this.selectedFieldSectionIndex = $event;
  }

  onValueChanged(event) {
    console.log('Value Changed at tab', event);
    // this.valueChanged.emit(event);
  }

  ngOnInit(): void {
    // this.reportingLogicConfig$ = this.dac6RepoterApiService.getReportingLogicConfig();
    this.activatedRoute.queryParams.pipe(take(1)).subscribe((queryParams: any) => {
      if (queryParams.tab != null) {
        this.tabIndex = +queryParams.tab;
        this.selectedFieldSectionIndex = this.tabIndex;
        this.viewDetails = true;
      }
      if (queryParams.child != null) {
        this.childIndex = +queryParams.child;
      }
    });
    const command = new SyncProjectEntityToCompanyCommand(false);
    this.fuseSplashscreen.show();
    this.commandService.executeCommand(command).pipe().subscribe(commandState => {
      console.log(commandState);
      this.fuseSplashscreen.hide();
      if (commandState.Payload.ConfirmationNeeded) {
        this.dialogService.showYesNoDialog('Confirm Sync', `You were working with the entities of project '${commandState.Payload.Configuration.ProjectModel.Name}'. Do you want to sync with the current project?`)
          .subscribe(state => {
            if (state.action === 'OK') {
              const command = new SyncProjectEntityToCompanyCommand(true);
              this.fuseSplashscreen.show();
              this.commandService.executeCommand(command).subscribe(value => {
                console.log(commandState);
                this.fuseSplashscreen.hide();
                this.subscribeToReportingLogicConfig();
              }, error => {
                this.fuseSplashscreen.hide();
                console.log(error);
              });
            } else {
              this.subscribeToReportingLogicConfig();
            }
          });
      } else {
        this.subscribeToReportingLogicConfig();
      }
    }, error => {
      this.fuseSplashscreen.hide();
      console.log(error);
    });

    // const activityInfo = {type: 'Tool', 'id': 'dac6-reporting-logic', 'title': 'Reporting Logic', isDefault: true};
    // this.platformSidebarStore.dispatch(new SetActivityFeedAction(activityInfo));
  }

  private subscribeToReportingLogicConfig() {
    this.reportingLogicConfig$ = this.dac6RepoterApiService.getReportingLogicConfig();
    this.reportingLogicConfig$.subscribe(o => {
      this.reportingLogicConfig = o;
      if (this.viewDetails) {
        this.hallmarkTagging();
      }
    });
  }

  setHelpNote($event){
    this.helpNote = $event;
  }

  ngOnDestroy(): void {
  }

  hallmarkTagging() {
    this.hallmarkTaggingService.openCommonHallmarkTaggingDialog(this.reportingLogicConfig[this.selectedFieldSectionIndex].children[this.childIndex].id);
  }

  setChildIndex($event: number) {
    this.childIndex = $event;
  }

  handler: IPlatformToolHandler;
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }
}
